import React, { useState, useEffect, useCallback } from 'react';
import middleware from "../../../Api/Middleware";
import { ButtonDarkBlue } from '../../../HouseStyle/Components/Buttons';
import ProductSeasonModal from './ProductSeasonModal';
import ToastError from '../../../Toasts/ToastError';
import ToastSuccess from "../../../Toasts/ToastSuccess";

const ProductSeasonsBox = ({ productId }) => {
  const [productSeasons, setProductSeasons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const fetchProductSeasons = useCallback(async () => {
    setLoading(true);
    try {
      const response = await middleware.get(`products/hasseasons?product_id=${productId}`);
      const data = response.data.data;
      if (Array.isArray(data)) {
        setProductSeasons(data);
      } else if (data) {
        setProductSeasons([data]);
      } else {
        setProductSeasons([]);
      }
    } catch (error) {
      console.error('Error fetching product seasons:', error);
      setProductSeasons([]);
    } finally {
      setLoading(false);
    }
  }, [productId]);

  useEffect(() => {
    if (productId) {
      fetchProductSeasons();
    }
  }, [productId, fetchProductSeasons]);

  const handleRemoveSeason = async (seasonId) => {
    try {
      await middleware.delete(`products/hasseasons?product_id=${productId}&season_id=${seasonId}`);

      setProductSeasons(prev => prev.filter(s => s.season_id !== seasonId));
      ToastSuccess('Seizoen succesvol verwijderd');
    } catch (error) {
      console.error('Error removing season:', error);
      ToastError('Fout bij het verwijderen van seizoen');
    }
  };

  const formatSeasonName = (season) => {
    if (season.sub_season) {
      return `${season.head_season} - ${season.sub_season}`;
    }
    return season.head_season;
  };

  const handleSeasonsSaved = () => {
    fetchProductSeasons();
  };

  return (
    <>
      <div className="whiteBox p-5">
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="inputTitle">Seizoenen</h4>
            <ButtonDarkBlue
              text="Seizoenen beheren"
              onClickFunction={() => setShowModal(true)}
            />
          </div>

          {loading ? (
            <div className="text-center py-2">
              <div className="spinner-border spinner-border-sm text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : productSeasons.length === 0 ? (
            <p className="mb-0">Geen seizoenen gekoppeld aan dit product.</p>
          ) : (
            <div className="d-flex flex-wrap gap-2">
              {productSeasons.map((season) => (
                <div
                  key={season.season_id}
                  className="badge bg-light text-dark border d-flex align-items-center gap-2 px-3 py-2"
                  style={{ fontSize: '14px' }}
                >
                  <span>{formatSeasonName(season.season)}</span>
                  <button
                    type="button"
                    className="btn-close btn-close-sm"
                    style={{ fontSize: '10px' }}
                    onClick={() => handleRemoveSeason(season.season_id)}
                    aria-label="Verwijderen"
                  >
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <ProductSeasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        productId={productId}
        currentSeasonIds={productSeasons.map(s => s.season_id)}
        onSeasonsSaved={handleSeasonsSaved}
      />
    </>
  );
};

export default ProductSeasonsBox;

